import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Checkbox, TextField, Typography, useDevice, WithInfoIcon } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { PreapprovalPeriodDropdown } from './PreapprovalPeriodDropdown';
import styles from './PreapprovalSettingsRow.module.scss';
export const GetPreapprovalSettingsRowTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            PreapprovalSettingsRowTID: {
                Checkbox: parentTestId ? "".concat(parentTestId, "-preapproved-amount-checkbox") : 'preapproved-amount-checkbox',
                Amount: parentTestId ? "".concat(parentTestId, "-preapproved-amount-input") : 'sb-cap',
                Period: parentTestId ? "".concat(parentTestId, "-preapproval-period-select") : 'preapproval-period-select',
                Tooltip: parentTestId ? "".concat(parentTestId, "-cap-tooltip") : 'sb-cap-tooltip'
            }
        }
    });
export function PreapprovalSettingsRow(param) {
    let { testId, checked, onCheckedChange, amount, onAmountChange, amountError, amountSuffix, showPeriodDropdown, periodValue, onPeriodChange, disabled, periodDisabled, className, hideFieldsWhenUnchecked, mobile } = param;
    const { isMobileDevice } = useDevice();
    const { t: preapprovalTexts } = useLocaleKeys('billing.preapproval');
    const { PreapprovalSettingsRowTID: tid } = useMemo(()=>GetPreapprovalSettingsRowTID(testId), [
        testId
    ]);
    const validateAmount = (value)=>{
        const numericVal = parseFloat(value);
        const isNonPositive = checked && !isNaN(numericVal) && numericVal <= 0;
        const isEmpty = checked && value.trim() === '';
        const isInvalid = isNonPositive || isEmpty;
        return {
            error: isInvalid,
            helperText: isInvalid ? preapprovalTexts.validation.setCapPositive() : ''
        };
    };
    const { error: amountInvalid, helperText } = validateAmount(amount);
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.wrapper,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.checkboxRow,
                children: /*#__PURE__*/ _jsxs(WithInfoIcon, {
                    info: /*#__PURE__*/ _jsx("div", {
                        "data-testid": tid.Tooltip(),
                        children: preapprovalTexts.tooltip()
                    }),
                    showInfo: true,
                    children: [
                        /*#__PURE__*/ _jsx(Checkbox, {
                            bi: {
                                name: 'preapproved_amount'
                            },
                            checked: checked,
                            disabled: disabled,
                            testId: tid.Checkbox(),
                            onChange: (e)=>onCheckedChange(e.target.checked)
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: disabled ? 'disabled' : 'standard',
                            onClick: ()=>!disabled && onCheckedChange(!checked),
                            style: {
                                cursor: disabled ? 'default' : 'pointer'
                            },
                            children: preapprovalTexts.checkboxLabel()
                        })
                    ]
                })
            }),
            (!hideFieldsWhenUnchecked || checked) && /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.fieldsRow, isMobileDevice && styles.mobile, className),
                children: [
                    /*#__PURE__*/ _jsx(TextField, {
                        bi: {
                            name: 'preapproved_amount_value'
                        },
                        mobile: mobile,
                        size: "small",
                        isMoney: true,
                        alwaysShrinkLabel: true,
                        label: preapprovalTexts.amountLabel(),
                        error: amountError || amountInvalid,
                        helperText: helperText,
                        validateInBottomSheet: validateAmount,
                        disabled: disabled,
                        value: amount,
                        suffix: amountSuffix,
                        noWrapSuffix: true,
                        testId: tid.Amount(),
                        onKeyDown: (e)=>{
                            if (e.key === '-') e.preventDefault();
                        },
                        onPaste: (e)=>{
                            if (e.clipboardData.getData('text').includes('-')) e.preventDefault();
                        },
                        onChange: (e)=>onAmountChange(e.target.value.replace(/-/g, '').slice(0, 7))
                    }),
                    showPeriodDropdown && /*#__PURE__*/ _jsx(PreapprovalPeriodDropdown, {
                        value: periodValue,
                        onChange: onPeriodChange,
                        disabled: disabled || periodDisabled,
                        testId: tid.Period(),
                        size: "small"
                    })
                ]
            })
        ]
    });
}
